import { Accordion } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AccordionStyled = styled(Accordion)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  overflow: 'hidden',

  [theme.breakpoints.up('xl')]: {
    width: '85vw',
  },

  ...(theme.palette.mode === 'light' && {
    border: '1px solid rgb(240, 242, 245) !important',
    boxShadow: '0px 2px 10px rgba(0,0,0,0.06)',
  }),

  ...(theme.palette.mode === 'dark' && {
    border: 'none',
    boxShadow: 'none',
  }),

  // Remove default MUI Accordion divider line
  '&:before': { display: 'none' },

  // When expanded, keep same "card" look (MUI adds margin)
  '&.Mui-expanded': {
    margin: 0,
  },

  '&.MuiAccordion-root': {
    borderRadius: 16,
  },

  // Summary (header)
  '& .MuiAccordionSummary-root': {
    minHeight: 56,
    padding: theme.spacing(2, 2.5),
    borderBottom: 'none',
  },

  // Only when expanded
  '& .MuiAccordionSummary-root.Mui-expanded': {
    minHeight: 56,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },

  '& .MuiAccordionSummary-content': {
    margin: 0,
    alignItems: 'center',
    gap: theme.spacing(1.25),
  },

  '& .MuiAccordionSummary-content.Mui-expanded': {
    margin: 0,
  },

  // Details (body)
  '& .MuiAccordionDetails-root': {
    padding: theme.spacing(2.5),
  },

  // Expand icon spacing
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: theme.palette.text.secondary,
  },
}));
